/**
 * Clears local storage, session storage (except for one parameter), and deletes all cookies.
 * @returns {void}
 */
const clearStorageAndCookies = () => {
  localStorage.clear();
  Object.keys(sessionStorage)?.forEach(key => {
    sessionStorage.removeItem(key);
  });
  document.cookie.split(";")?.forEach(cookie => {
    const eqPos = cookie.indexOf("=");
    const name = eqPos > -1 ? cookie.substr(0, eqPos).trim() : cookie.trim();
    document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/`;
  });
};

export default clearStorageAndCookies;
